module.exports = __webpack_public_path__ + "img/LaBase-Mole-burger-600.60c3e25a.jpg";